"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _imageSrc = require("../../lib/imageSrc");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _CardFooter = _interopRequireDefault(require("../../components/CardFooter"));
var _reactBootstrap = require("react-bootstrap");
var _utils = require("../../utils");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a horizontal card
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A horizontal card
 */
function HorizontalCard(props) {
  var _props$rendering;
  if (!((_props$rendering = props.rendering) !== null && _props$rendering !== void 0 && _props$rendering.fields)) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl,
    linkTarget,
    linkAlt
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.Link.value);
  var imageColSize = (0, _lodash.defaultTo)(props.imageColSize, 7);
  var bodyColSize = (0, _lodash.defaultTo)(props.bodyColSize, 5);
  var imagePlacement = extractedFields.ImageAlignment.value ? extractedFields.ImageAlignment.value : 'left';
  var CardImage = extractedFields => {
    var cssClass = extractedFields.imgFluid.value ? 'mm-img' : "mm-img-".concat(imagePlacement);
    return /*#__PURE__*/_react.default.createElement("picture", {
      className: cssClass
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _imageSrc.imageHref)(extractedFields.Image.value),
      alt: extractedFields.Image.value.alt
    }));
  };
  var Title = extractedFields => {
    if ((0, _lodash.isEmpty)(extractedFields.Title.value)) return null;
    if (linkUrl !== '#') {
      return (0, _titleHeadTag.headTagTitleWithAnchor)(extractedFields.Title, undefined, extractedFields.TitleSize.value, linkUrl, linkTarget, linkAlt);
    } else {
      return (0, _titleHeadTag.headTagTitle)(extractedFields.Title, undefined, extractedFields.TitleSize.value);
    }
  };
  var CardBody = extractedFields => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, {
      className: "".concat(extractedFields.TextCenterAligned.value ? 'mm-text-center' : '')
    }, !(0, _lodash.isEmpty)(extractedFields.Eyebrow.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, extractedFields.Eyebrow.value), /*#__PURE__*/_react.default.createElement(Title, extractedFields), !(0, _lodash.isEmpty)(extractedFields.PreviewText.value) && /*#__PURE__*/_react.default.createElement("div", {
      className: extractedFields.PreviewTextStyle.value
    }, (0, _richTextField.parseHTML)(extractedFields.PreviewText)), /*#__PURE__*/_react.default.createElement(_CardFooter.default, {
      buttonType: extractedFields.ButtonType.value,
      linkUrl: linkUrl,
      linkTarget: linkTarget,
      linkAlt: linkAlt,
      buttonTxt: extractedFields.Text.value,
      ctaIcon: extractedFields.ctaIcon.value,
      ctaIconDirection: extractedFields.ctaIconPlacement.value,
      callOut: (0, _richTextField.parseHTML)(extractedFields.Callout),
      ctaDataId: extractedFields.ctaDataId.value
    }));
  };
  var CardWithImage = extractedFields => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      sm: 12,
      md: imagePlacement === 'right' ? {
        span: imageColSize,
        order: 'last'
      } : {
        span: imageColSize
      }
    }, /*#__PURE__*/_react.default.createElement(CardImage, extractedFields)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      sm: 12,
      md: {
        span: bodyColSize
      }
    }, /*#__PURE__*/_react.default.createElement(CardBody, extractedFields)));
  };
  var CardHorizontalLayout = extractedFields => {
    if (!(0, _lodash.isEmpty)(extractedFields.Image.value)) return /*#__PURE__*/_react.default.createElement(CardWithImage, extractedFields);else return /*#__PURE__*/_react.default.createElement(CardBody, extractedFields);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container hcard"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: extractedFields.Variant.value
  }, /*#__PURE__*/_react.default.createElement(CardHorizontalLayout, extractedFields)));
}
var _default = exports.default = HorizontalCard;